import { render } from "./GridModule.vue?vue&type=template&id=45ba9a70&ts=true"
import script from "./GridModule.vue?vue&type=script&lang=ts"
export * from "./GridModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__